/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-10.
 * Form configuration for despachos
 */
import { AUTOCOMPLETE, TEXT, REMOTE_AUTOCOMPLETE } from '../components/data-containers/formBuilder/types';
import { COUNTRY_LIST } from '../data/selects';


export const getConfig = (actions) => {
    return {
        fields: [
            {
                fType: TEXT,
                key: 'name',
                floatingLabelFixed: true,
                floatingLabelText: 'Razon Social',
                hintText: 'S.A de C.V.',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'taxId',
                floatingLabelFixed: true,
                floatingLabelText: 'RFC / Tax Id',
                hintText: 'RFC ó Tax Id',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'street',
                floatingLabelFixed: true,
                floatingLabelText: 'Calle',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'externalNumber',
                floatingLabelFixed: true,
                floatingLabelText: 'Número Exterior',
                hintText: '11A',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'internalNumber',
                floatingLabelFixed: true,
                floatingLabelText: 'Número Interior',
                hintText: '11A',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'zipCode',
                floatingLabelFixed: true,
                floatingLabelText: 'Codigo Postal',
                hintText: '45066',
                fullWidth: true,
            },
            {
                fType: TEXT,
                key: 'colony',
                floatingLabelFixed: true,
                floatingLabelText: 'Colonia',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'city',
                floatingLabelFixed: true,
                floatingLabelText: 'Ciudad',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'municipality',
                floatingLabelFixed: true,
                floatingLabelText: 'Municipio',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'state',
                floatingLabelFixed: true,
                floatingLabelText: 'Estado',
                hintText: 'Nombre',
                fullWidth: true
            },
            {
                fType: AUTOCOMPLETE,
                key: 'country',
                floatingLabelFixed: true,
                label: 'País',
                hintText: 'México',
                fullWidth: true,
                data: COUNTRY_LIST

            },
        ],
        rules: {
            name: [{ key: 'required', errorText: 'Campo requerido' }],
            taxId: [{ key: 'required', errorText: 'Campo requerido' }],
            phone1: [
                { key: 'required', errorText: 'Campo requerido' },
                { key: 'onlyNumbers', errorText: 'Solo Números' },
                { key: 'validationPhone1', errorText: 'Numero telefónico tiene que ser de 10 dígitos' }
            ],
            email1: [
                { key: 'required', errorText: 'Campo requerido' },
                { key: 'validationEmail', errorText: 'Ingrese un correo válido' }
            ],
            street: [{ key: 'required', errorText: 'Campo requerido' }],
            externalNumber: [
                { key: 'required', errorText: 'Campo requerido' }
            ],
            zipCode: [
                { key: 'required', errorText: 'Campo Requerido' },
                { key: 'validationZipCode', errorText: 'Código postal tiene que ser menor o igual a 10 dígitos' }
            ],
            country: [{ key: 'required', errorText: 'Campo requerido' }]
        }
    };
};



// WEBPACK FOOTER //
// ./forms/proveedor.js